module.exports = __webpack_public_path__ + "static/media/Skjermbilde-A.789bfaec.png";